import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

let idCounter = 0;
let emitter = null;

export function pushToast(message, kind = "info", duration = 3500) {
  if (emitter) emitter({ id: ++idCounter, message, kind, duration });
}

export default function Toaster() {
  const [toasts, setToasts] = useState([]);
  const timers = useRef({});

  useEffect(() => {
    emitter = (t) => {
      setToasts((prev) => [...prev, t]);
      timers.current[t.id] = setTimeout(() => {
        setToasts((prev) => prev.filter((x) => x.id !== t.id));
        delete timers.current[t.id];
      }, t.duration);
    };
    const localTimers = timers.current;
    return () => {
      emitter = null;
      Object.values(localTimers).forEach(clearTimeout);
    };
  }, []);

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            initial={{ opacity: 0, y: 12, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.98 }}
            transition={{ duration: 0.18, ease: "easeOut" }}
            className={
              "pointer-events-auto max-w-sm px-3 py-2 rounded-lg border text-sm shadow-soft " +
              (t.kind === "error"
                ? "bg-rose-950/80 border-rose-500/40 text-rose-100"
                : t.kind === "warn"
                ? "bg-amber-900/60 border-amber-500/40 text-amber-100"
                : t.kind === "success"
                ? "bg-emerald-950/70 border-emerald-500/40 text-emerald-100"
                : "bg-ide-panel border-ide-border text-ide-text")
            }
          >
            {t.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
